import { render, staticRenderFns } from "./GlobalDashboard.vue?vue&type=template&id=bbd1f22e&scoped=true&"
import script from "./GlobalDashboard.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboard.vue?vue&type=style&index=0&id=bbd1f22e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd1f22e",
  null
  
)

export default component.exports